<mat-dialog-content class="modal-header"><h2 mat-dialog-title>APROBACIÓN SOLICITUD</h2></mat-dialog-content>

    <mat-dialog-content class="modal-body">
      <div class="content">
        <div class="form-horizontal">
            <div class="form-group">
                <label class="col-md-3 control-label">Fecha Limite Anterior:</label>
                <div class="col-md-5">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Fecha Limite Anterior</mat-label>
                    <input
                        matInput
                        id="fechaCierre"
                        name="fechaCierre"
                        disabled value="{{ model.plazoAnterior | date:'dd/MM/yyyy' }}"
                    />
                    </mat-form-field>
                </div>
            </div>
            <div class="form-group"  *ngIf="existeAprobado">
                <label class="col-md-3 control-label">Nueva Fecha Limite:</label>
                <div class="col-md-5">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Nueva Fecha Limite</mat-label>
                    <input
                        matInput [min]="minDate" [max]="maxDate"
                        [matDatepicker]="pckrnuevoPlazo"
                        [(ngModel)]="model.nuevoPlazo" 
                        id="nuevoPlazo"
                        name="nuevoPlazo"
                        required
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="pckrnuevoPlazo"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrnuevoPlazo></mat-datepicker>
                    <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
                    </mat-form-field>
                </div>
            </div>   
        </div>  
      </div>  
      <div class="content">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-md-3 control-label">Comentarios:</label>
            <div class="col-md-9">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Comentarios</mat-label>
                <textarea
                  matInput
                  placeholder="Motivo"
                  rows="5"
                  [(ngModel)]="model.comentarios" 
                  name="comentarios" maxlength="2000" required
                ></textarea>
                <!-- 
                  [disabled]="modelPersona.idEstado === 2" -->
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end" class="modal-actions">
      <button type="submit" class="btn btn-naranja" (click)="Save()"
      [disabled]="!esValido()" mat-button ><mat-icon>send</mat-icon> Enviar</button> 
      <!-- [disabled]="!EsValido()" -->
      <!-- [mat-dialog-close]="data" -->
      <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" [disabled]="modelForm.invalid" (click)="guardar()">Submit</button> -->
      <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()" ><mat-icon>exit_to_app</mat-icon> Salir</button>
    </mat-dialog-actions>
    